import React from 'react';


const Payment = () => {
    return (
        <div>

<h3 className='text 2xl md:text-4xl text-center font-semibold my-10'>Complete Your Payment</h3>
        </div>
    );
};

export default Payment;